import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SentEmailIcon = () => (
  <ImageIcon src={Images.SentEmail} alt="empty-data/" />
);

export default SentEmailIcon;
